import { Component, OnInit } from "@angular/core"
import { Title } from "@angular/platform-browser"
import { ActivatedRoute, Router } from "@angular/router"
import { DeprecatedGradeURImap, GRADE_BANDS, PBSLM_TITLE } from "../models/constants"
import { GradeBand } from "../models/gradeBand.model"

import { BrowsingService } from "../services/browsing.service"
import { redirectToError } from "../utils/error-handling"
import { UserService } from "../services/user.service"
import { Location } from "@angular/common"
import { AddOnViewService } from "../services/add-on-view.service"
import { routeAnimations, routeTransition } from "../utils/animations"

@Component({
    selector: "app-browse-by-grade",
    templateUrl: "./browse-by-grade.component.html",
    styleUrls: ["./browse-by-grade.component.scss"],
    host: { "[@routeTransition]": "true", "[@routeAnimations]": "false", style: "display: block;" },
    animations: [routeTransition, routeAnimations],
    standalone: false,
})
export class BrowseByGradeComponent implements OnInit {
    gradeBand: GradeBand
    isAddOnView: boolean

    constructor(
        private browsingService: BrowsingService,
        private route: ActivatedRoute,
        private titleService: Title,
        private router: Router,
        public userService: UserService,
        private location: Location,
        private addOnViewService: AddOnViewService
    ) {}

    public ngOnInit() {
        this.isAddOnView = this.addOnViewService.isAddonView
        this.route.params.subscribe((params) => {
            this.configureGradeBand(params.grade)
        })
    }

    // TODO we can remove this logic if we can confirm that older routes are not used anymore
    private configureGradeBand(gradeBandUriParam: string) {
        const gradeBand = GRADE_BANDS.find(
            (gb) => gb.uri.toLowerCase() === gradeBandUriParam.toLowerCase()
        )
        let deprecatedRouteMatched = false
        Object.keys(DeprecatedGradeURImap).forEach((gradeBandURIKey) => {
            if (gradeBandUriParam.toLowerCase() === gradeBandURIKey) {
                const correspondingGradeBand = GRADE_BANDS.find(
                    (gradeBand) => gradeBand.uri === DeprecatedGradeURImap[gradeBandURIKey]
                )
                this.router.navigateByUrl(`/grades/${correspondingGradeBand.uri}`)
                deprecatedRouteMatched = true
            }
        })

        if (!gradeBand && !deprecatedRouteMatched) {
            redirectToError(this.router, this.location, "404")
        }

        this.gradeBand = gradeBand
        this.titleService.setTitle(`${gradeBand?.metaTitle} | ${PBSLM_TITLE}`)
    }
}
